export default [
  {
    path: '/api/master/user',
    name: 'UserMaster',
    meta: {
      pageTitle: '기준정보 관리',
      title: '사용자 관리',
      authRequired: true,
    },
    component: () => import('@/views/master/userMaster')
  },
  {
    path: '/api/master/menu',
    name: 'MenuMaster',
    meta: {
      pageTitle: '기준정보 관리',
      title: '메뉴 관리',
      authRequired: true,
    },
    component: () => import('@/views/master/menuMaster')
  },
  {
    path: '/api/master/role',
    name: 'RoleMaster',
    meta: {
      pageTitle: '기준정보 관리',
      title: '권한 관리',
      authRequired: true,
    },
    component: () => import('@/views/master/roleMaster')
  },
  {
    path: '/api/master/code',
    name: 'CodeMaster',
    meta: {
      pageTitle: '기준정보 관리',
      title: '공통코드 관리',
      authRequired: true,
    },
    component: () => import('@/views/master/codeMaster')
  },

]
